import request from '@/utils/request'


//查询公司新闻/行业动态
export function getNewsList(query) {
  return request({
    url: '/api/websiteArticle/getNewsList',
    method: 'get',
    params: query
  })
}
//通过id查询新闻详情
export function findNewsById(query) {
  return request({
    url: '/api/websiteArticle/findNewsById',
    method: 'get',
    params: query
  })
}


//查询功效分类列表
export function geteffectList() {
  return request({
    url: '/api/websiteArticle/geteffectList',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/news.js